import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';


import { AuthService } from '../auth/auth.service';
import { AppStorageService } from '../share/appstorage.service';
import { AppSettings } from '../../settings';

@Component({
  selector: 'app-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: ['./layouts.component.css']
})
export class LayoutsComponent implements OnInit {
  translate: TranslateService;
  saldo: number;
  showBack = false;
  isManager: boolean;
  isAdmin: boolean;
  isBetshopUser: boolean;
  languageFromStorage: string;

  constructor(
    translate: TranslateService,
    public _authService: AuthService,
    private _storage: AppStorageService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _settings: AppSettings,
    ) {
    this.getCurrentUser();

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    this.translate = translate;
    this.languageFromStorage = _storage.getAppsLang();
    if (this.languageFromStorage != null)
      this.setLanguage(this.languageFromStorage);
    else
      this.setLanguage(this._settings.defaultLanguage);
  }

  ngOnInit() {
    this.isBetshopUser = this._storage.getIsBetshopUser() === 'true';
  }

  private setLanguage(language: string) {
    if (this.languageFromStorage === null)
      this._storage.setAppsLang(language);

    this.translate.use(language);
  }

  getCurrentUser() {
    this._authService.getUser().subscribe(
      data => {
        this._storage.setUsersUsername(data);
          this._router.navigate(['state']);
        },
      err => {
        throw err;
      }
    );
  }

  logout() {
    this._authService.logout();
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/layouts/layouts.component.ts